module.exports = __webpack_public_path__ + "static/img/2026_omikuji_banner.12089b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2026/2026_omikuji_banner.png
// module id = 4cH6
// module chunks = 7